<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Contact info: full width on top (mobile / tablet) — phones only -->
    <div class="navbar-support navbar-support-mobile d-xl-none">
      <div class="navbar-support-block">
        <span class="navbar-support-text">
          Customer Service:
          <feather-icon icon="PhoneIcon" size="14" class="navbar-support-icon" />
          16676,
          <feather-icon icon="PhoneIcon" size="14" class="navbar-support-icon" />
          +8809645006463
        </span>
        <span class="navbar-support-email">
          <feather-icon icon="MailIcon" size="14" class="navbar-support-icon" />
          info.mime@cg-bd.com
        </span>
      </div>
    </div>

    <div class="navbar-main-row d-flex align-items-center flex-nowrap w-100 min-w-0">
      <!-- Nav Menu Toggler -->
      <ul class="nav navbar-nav d-xl-none flex-shrink-0">
        <li class="nav-item">
          <b-link class="nav-link" @click="toggleVerticalMenuActive">
            <feather-icon icon="MenuIcon" size="21" />
          </b-link>
        </li>
      </ul>

      <!-- Wallet + OD -->
      <div class="bookmark-wrapper navbar-left flex-grow-1 d-flex min-w-0">
        <dark-Toggler class="d-none d-lg-block flex-shrink-0" />

        <div class="navbar-balance-group d-flex align-items-center flex-nowrap min-w-0">
          <button
            type="button"
            class="btn btn-sm navbar-balance-btn flex-shrink-0"
            :disabled="isBalanceLoading"
            @click="handleCheckBalance"
          >
            <span class="navbar-balance-label">Wallet:</span>
            <span v-if="isBalanceLoading" class="navbar-balance-value">
              <b-spinner small type="grow" />
            </span>
            <span v-else class="navbar-balance-pill">
              {{ showBalance ? balance + " BDT" : "Check Balance" }}
            </span>
          </button>

          <span class="navbar-od-balance flex-shrink-0">
            <span class="navbar-balance-label">Over Due:</span>
            <span class="navbar-od-value">
              {{ userDetails && userDetails.od_balance ? userDetails.od_balance : 0 }} BDT
            </span>
          </span>
        </div>
      </div>

      <!-- Customer Service centered (PC) -->
      <div class="navbar-support navbar-support-desktop d-none d-xl-flex">
        <div class="navbar-support-block">
          <span class="navbar-support-text">
            Customer Service:
            <feather-icon icon="PhoneIcon" size="16" class="navbar-support-icon" />
            16676,
            <feather-icon icon="PhoneIcon" size="16" class="navbar-support-icon" />
            +8809645006463
          </span>
          <span class="navbar-support-email">
            <feather-icon icon="MailIcon" size="15" class="navbar-support-icon" />
            info.mime@cg-bd.com
          </span>
        </div>
      </div>

      <b-navbar-nav class="nav align-items-center ml-auto flex-shrink-0">
        <b-nav-item-dropdown
          right
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-user"
        >
          <template #button-content>
            <div class="d-sm-flex d-none user-nav">
              <p class="user-name font-weight-bolder mb-0">
                {{ userData.username }}
              </p>
              <span class="user-status"
                >{{ userData.fullname }}
                {{
                  userDetails && userDetails.company
                    ? " | " + userDetails.company
                    : ""
                }}</span
              >
            </div>
            <b-avatar
              size="40"
              variant="light-primary"
              badge
              :src="'/storage/' + userData.employee_avatar_file_path"
              class="badge-minimal"
              badge-variant="success"
            />
          </template>
          <b-dropdown-item
            link-class="d-flex align-items-center"
            :to="{ name: 'profile.details' }"
          >
            <feather-icon size="16" icon="UserIcon" class="mr-50" />
            <span>My Profile</span>
          </b-dropdown-item>
          <b-dropdown-item
            link-class="d-flex align-items-center"
            :to="{ name: 'profile.change-password' }"
          >
            <feather-icon size="16" icon="EditIcon" class="mr-50" />
            <span>Change Password</span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
            <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
  </div>
</template>

<script>
import {
  BLink,
  BTooltip,
  BButton,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BSpinner,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import NotificationDropdown from "@core/layouts/components/app-navbar/components/NotificationDropdown.vue";
import api from "@/services/api";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { decrypt } from "@/utils/crypto";
export default {
  components: {
    BLink,
    BTooltip,
    BButton,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BSpinner,
    vSelect,
    // Navbar Components
    DarkToggler,
    NotificationDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    const userData = decrypt(localStorage.getItem("userData"));
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    return {
      app_env: "",
      userData,
      userDetails,
      showNotification: false,
      balance: null,
      showBalance: false,
      isBalanceLoading: false,
      balanceTimeout: null,
      loadingCustomers: false,
      customerList: [],
      customerMap: {}, // Store customer data by username
    };
  },
  methods: {
    logout() {
      var _this = this;

      let loader = _this.$loading.show();

      localStorage.removeItem("accessToken");
      localStorage.removeItem("app_env");
      localStorage.removeItem("userData");
      localStorage.removeItem("userDetails");
      localStorage.removeItem("settingSystem");

      this.$router.push({
        name: "login",
      });

      loader.hide();

      _this.$toast({
        component: ToastificationContent,
        props: {
          title: `Success`,
          text: `Successfully logged out.`,
          icon: "CheckIcon",
          variant: "success",
        },
      });
      window.location.reload();
    },
    async handleCheckBalance() {
      if (this.isBalanceLoading) return;
      this.isBalanceLoading = true;
      const username = this.userData?.username;
      try {
        const response = await api.get(
          `/selfcare/api/v1/customer/${username}/`,
        );
        this.balance = this.formatBDT(response.data.balance);
        this.showBalance = true;
        this.isBalanceLoading = false;
        if (this.balanceTimeout) clearTimeout(this.balanceTimeout);
        this.balanceTimeout = setTimeout(() => {
          this.showBalance = false;
        }, 5000);
      } catch (e) {
        this.isBalanceLoading = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text:
              e.response?.data?.message ||
              e.message ||
              "Failed to fetch balance",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },

    formatBDT(amount) {
      if (amount === null || amount === undefined) return "0.0";

      // Determine sign and work with absolute value
      const isNegative = amount < 0;
      const absAmount = Math.abs(amount);

      // Split into integer and decimal parts (keep 1 decimal as per API response)
      const [integerPart, decimalPart] = absAmount.toFixed(1).split(".");

      // Add commas to integer part (thousands separator)
      const formattedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ",",
      );

      // Reassemble with sign
      return (isNegative ? "-" : "") + formattedInteger + "." + decimalPart;
    },
  },
  created() {
    var _this = this;
    _this.app_env = localStorage.getItem("app_env");
  },
  beforeDestroy() {
    if (this.balanceTimeout) clearTimeout(this.balanceTimeout);
  },
};
</script>
<style lang="scss">
.dropdown-menu {
  width: 15rem !important;
}
@import "@core/scss/vue/libs/vue-select.scss";

.navbar-container {
  position: relative;
  flex-wrap: wrap !important;
  min-width: 0;
  gap: 0.25rem 0.5rem;
}

.navbar-main-row {
  position: relative;
  min-width: 0;
  gap: 0.5rem;
}

.navbar-left {
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  overflow: hidden;
}

.navbar-balance-group {
  gap: 0.5rem;
  min-width: 0;
}

.navbar-balance-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
  padding: 0.25rem 0.35rem;
  line-height: 1.2;
  min-width: 0;
  max-width: 100%;
}

.navbar-balance-label {
  font-weight: 700;
  font-size: 0.9375rem;
  white-space: nowrap;
}

.navbar-balance-pill,
.navbar-od-value {
  display: inline-block;
  background: #7367f0;
  color: #fff;
  padding: 0.2rem 0.45rem;
  border-radius: 5px;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;
}

.navbar-od-balance {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
  font-size: 0.9375rem;
  list-style: none;
}

.navbar-support-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  min-width: 0;
}

.navbar-support-text {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
  font-size: 1.0625rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.3;
}

.navbar-support-email {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.9375rem;
  font-weight: 600;
  white-space: nowrap;
  margin: 0;
  line-height: 1.2;
}

.navbar-support-icon {
  flex-shrink: 0;
}

/* Centered on PC */
.navbar-support-desktop {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  align-items: center;
  max-width: min(54%, 640px);
  pointer-events: none;
  z-index: 1;

  .navbar-support-block {
    pointer-events: auto;
  }

  .navbar-support-text,
  .navbar-support-email {
    white-space: nowrap;
  }
}

/* Full-width contact on top (mobile / tablet) */
.navbar-support-mobile {
  flex: 0 0 100%;
  width: 100%;
  max-width: 100%;
  order: -1;
  text-align: center;
  padding: 0.1rem 0;

  .navbar-support-block {
    justify-content: center;
    width: 100%;
  }

  .navbar-support-text {
    justify-content: center;
    width: 100%;
    font-size: 0.75rem;
    gap: 0.35rem;
    white-space: nowrap;
  }

  .navbar-support-email {
    justify-content: center;
    width: 100%;
    font-size: 0.6875rem;
    gap: 0.3rem;
  }
}

@media (max-width: 991.98px) {
  .navbar-balance-label {
    font-size: 0.75rem;
  }

  .navbar-balance-pill,
  .navbar-od-value {
    font-size: 0.6875rem;
    padding: 0.15rem 0.35rem;
  }

  .navbar-balance-group {
    gap: 0.35rem;
  }
}

@media (max-width: 575.98px) {
  .navbar-balance-btn,
  .navbar-od-balance {
    gap: 0.25rem;
  }

  .navbar-balance-label {
    font-size: 0.6875rem;
  }

  .navbar-support-mobile .navbar-support-text {
    font-size: 0.6875rem;
    gap: 0.25rem;
  }

  .navbar-support-mobile .navbar-support-email {
    font-size: 0.625rem;
    gap: 0.2rem;
  }
}

/* Narrower desktop widths: keep the centered contact block from overlapping */
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .navbar-support-desktop {
    max-width: min(46%, 480px);
  }

  .navbar-support-desktop .navbar-support-text {
    font-size: 0.9375rem;
  }

  .navbar-support-desktop .navbar-support-email {
    font-size: 0.875rem;
  }
}

/* Allow header to fit stacked support on smaller screens */
@media (max-width: 1199.98px) {
  .header-navbar .navbar-container {
    min-height: 4.45rem;
    height: auto !important;
    padding-top: 0.35rem;
    padding-bottom: 0.35rem;
  }
}
</style>
